// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".simpletable-editor .theme--light.v-text-field--solo>.v-input__control>.v-input__slot{background-color:transparent}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
